import { RB_LOADING, RB_SUCCESS, RB_FAIL } from "../actions/revenue_bridge_actions";

const initial = { loading: false, data: null, error: null };

const revenueBridgeReducer = (state = initial, action) => {
  switch (action.type) {
    case RB_LOADING:
      // Keep the previous data while refetching so a range change does not blank
      // the panel — but clear the error, or a stale failure outlives its cause.
      return { ...state, loading: true, error: null };
    case RB_SUCCESS:
      return { loading: false, data: action.payload, error: null };
    case RB_FAIL:
      // Drop the data on failure. Showing the last good numbers next to an error
      // is how someone ends up trusting figures the server just refused to stand
      // behind.
      return { loading: false, data: null, error: action.payload };
    default:
      return state;
  }
};

export default revenueBridgeReducer;
